import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
// material
import {
  Typography,
  Box,
  CircularProgress,
  List,
  ListItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Menu,
  MenuItem
} from '@mui/material';
import { Icon } from '@iconify/react';
import trashFill from '@iconify/icons-eva/trash-2-fill';
import editFill from '@iconify/icons-eva/edit-2-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { grey } from '@mui/material/colors';
// components
import TicketFormEditDialog from './form/edit/dialog';
import TicketBatchesDialog from './batches/dialog';
import TicketVouchersDialog from './vouchers/dialog';
// contexts
import { EventContext } from '../../contexts/Event';
import { TicketsContext } from '../../contexts/Tickets';
import { useAuth } from '../../contexts/Auth';
import { SettingsContext } from '../../contexts/Settings';
// helpers
import { numberFormat } from '../../helpers/Util';
// services
import { removeFromInventory } from '../../services/Inventory';
import { deleteTicket } from '../../services/Ticket';
import { deleteSection } from '../../services/Section';

TicketList.propTypes = {
  section: PropTypes.object
};

export default function TicketList({ section }) {
  const { authUser } = useAuth();
  const { authSettings } = useContext(SettingsContext);
  const { event } = useContext(EventContext);
  const { tickets, setTickets } = useContext(TicketsContext);

  const [isLoading, setIsLoading] = useState(false);
  const [focusTicket, setFocusTicket] = useState();
  const [openTicketFormEditDialog, setOpenTicketFormEditDialog] = useState(false);
  const [openTicketBatchesDialog, setOpenTicketBatchesDialog] = useState(false);
  const [openTicketVouchersDialog, setOpenTicketVouchersDialog] = useState(false);

  const handleOpenTicketEditDialog = (ticket) => {
    setFocusTicket(ticket);
    setOpenTicketFormEditDialog(true);
  };

  const handleOpenTicketBatchesDialog = (ticket) => {
    setFocusTicket(ticket);
    setOpenTicketBatchesDialog(true);
  };

  const handleOpenTicketVouchersDialog = (ticket) => {
    setFocusTicket(ticket);
    setOpenTicketVouchersDialog(true);
  };

  const handleTicketDelete = async (ticket) => {
    if (!window.confirm(`Do you really want to delete this ticket: "${ticket.name}"?`)) {
      return;
    }

    setIsLoading(true);

    try {
      const idToken = await authUser.getIdToken();
      const headers = {
        Authorization: `Bearer ${idToken}`,
        'Account-Key': authSettings.server.path
      };

      await deleteTicket({
        headers,
        eventId: event._id,
        sectionId: ticket.section._id,
        ticketId: ticket._id
      });

      if (ticket.section.single) {
        await deleteSection({ headers, eventId: event._id, sectionId: ticket.section._id });
        // TODO: Funciona sem. Estaava dando erro
        // setSections((sections) =>
        //   sections.filter((currentSection) => currentSection._id !== ticket.section._id)
        // );
      }

      setTickets((tickets) => {
        tickets = {
          ...tickets,
          [ticket.section._id]: tickets[ticket.section._id].filter(
            (currentTicket) => currentTicket._id !== ticket._id
          )
        };

        return tickets;
      });

      // TODO: Atualizar usando kafka (provisório)
      const payloadServices = {
        section: {
          _id: ticket.section._id
        },
        ticket: {
          _id: ticket._id
        }
      };

      await removeFromInventory({ headers, payload: payloadServices });
      // TODO: quando exclui o ultimo ticket não mostra as opções de criar ticket e criar section
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert('An error occurred! Please, try again.');
    }

    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={3}>
        <CircularProgress color="inherit" />
      </Box>
    );
  }

  // TODO: Ficou muito grande o código. Dividir em components menores
  return (
    <>
      {Boolean(tickets && tickets[section._id] && tickets[section._id].length) && (
        <List>
          {tickets[section._id].map((ticket) => (
            <Box key={ticket._id} sx={{ background: grey[100], borderRadius: '20px', mb: 1, p: 1 }}>
              <ListItem
                secondaryAction={
                  <PopupState variant="popover" popupId="demo-popup-menu">
                    {(popupState) => (
                      <>
                        <IconButton {...bindTrigger(popupState)}>
                          <Icon icon={moreVerticalFill} />
                        </IconButton>
                        <Menu
                          {...bindMenu(popupState)}
                          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                          <MenuItem
                            aria-label="edit"
                            onClick={() => {
                              popupState.close();
                              handleOpenTicketEditDialog(ticket);
                            }}
                            sx={{ minWidth: '200px' }}
                          >
                            <ListItemIcon sx={{ mr: 0 }}>
                              <Icon color={grey[600]} icon={editFill} width="24" />
                            </ListItemIcon>
                            Edit
                          </MenuItem>

                          <MenuItem
                            aria-label="delete"
                            onClick={() => {
                              popupState.close();
                              handleTicketDelete(ticket);
                            }}
                            sx={{ minWidth: '200px' }}
                          >
                            <ListItemIcon sx={{ mr: 0 }}>
                              <Icon color={grey[600]} icon={trashFill} width="24" />
                            </ListItemIcon>
                            Delete
                          </MenuItem>

                          <Divider />

                          <Box sx={{ mt: 2, mb: 1, px: 2 }}>
                            <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                              Discount Rules
                            </Typography>
                          </Box>

                          <MenuItem
                            onClick={() => {
                              popupState.close();
                              handleOpenTicketBatchesDialog(ticket);
                            }}
                            disabled={Boolean(ticket.vouchers.length)}
                          >
                            Batches
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              popupState.close();
                              handleOpenTicketVouchersDialog(ticket);
                            }}
                            disabled={Boolean(ticket.rules.length)}
                          >
                            Vouchers
                          </MenuItem>
                        </Menu>
                      </>
                    )}
                  </PopupState>
                }
              >
                <ListItemText
                  sx={{ width: '60%' }}
                  primary={
                    <>
                      {ticket.name}
                      <Typography sx={{ mb: 2 }} color="textSecondary">
                        <small>ref. {ticket.reference}</small>
                      </Typography>
                    </>
                  }
                  secondary={numberFormat(ticket.price)}
                />
                {/* TODO: Tem que trocar pra usar o inventário no limit */}
                <ListItemText secondary={`Limit ${ticket.limit}`} />
              </ListItem>
            </Box>
          ))}
        </List>
      )}

      <TicketFormEditDialog
        openTicketFormEditDialog={openTicketFormEditDialog}
        setOpenTicketFormEditDialog={setOpenTicketFormEditDialog}
        ticket={focusTicket}
      />

      <TicketBatchesDialog
        openTicketBatchesDialog={openTicketBatchesDialog}
        setOpenTicketBatchesDialog={setOpenTicketBatchesDialog}
        ticket={focusTicket}
      />

      <TicketVouchersDialog
        openTicketVouchersDialog={openTicketVouchersDialog}
        setOpenTicketVouchersDialog={setOpenTicketVouchersDialog}
        ticket={focusTicket}
      />
    </>
  );
}
